<template>
  <ppt-modal class="set-weight-to-apply-to-added-hands-modal">
    <header slot="header">
      <h4 class="modal-title">Set weight to apply to added hands</h4>
      <button class="close" data-dismiss="modal"><span>&times;</span></button>
    </header>
    <section slot="body">
      <p>When you add hands to the range, those hands will be given a weight indicated by the value of the slider below.</p>
      <p>Eg. if you set the slider to 70 and then add AA, AA will have a weight of 70.</p>
      <vue-slider
        ref="slider"
        v-model="weightToApplyToAddedHandsVModel"
        v-bind="sliderOptions"
        v-on:callback="$emit('setWeightToApplyToAddedHands', weightToApplyToAddedHandsVModel)"
      ></vue-slider>
    </section>
  </ppt-modal>
</template>

<script>
import PPTModal from '@/components/utilities/modal';
import VueSlider from 'vue-slider-component';

export default {
  name: 'set-weight-to-apply-to-added-hands-modal',
  components: {
    'ppt-modal': PPTModal,
    'vue-slider': VueSlider,
  },
  props: ['weightToApplyToAddedHands'],
  data: function () {
    return {
      sliderOptions: {
        min: 5,
        interval: 5,
      },
      weightToApplyToAddedHandsVModel: 100,
    };
  },
  mounted: function () {
  	let self = this;

  	$(this.$el).on('shown.bs.modal', function () {
      self.weightToApplyToAddedHandsVModel = self.weightToApplyToAddedHands;
      self.$nextTick(function () {
        if (self.$refs.slider) {
          self.$refs.slider.refresh();
        }
      });
    });
  },
};
</script>

<style lang="scss" scoped>
  .modal-header {
    h4 {
      float: left;
      position: relative;
      top: 5px;
    }

    .close {
      position: relative;
      top: 5px;
    }
  }

  .vue-slider-component {
    margin-top: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/hand-range/hand-weight/set-weight-to-apply-to-added-hands-modal.vue